<soho-header #SohoHeader [hasTabs]="hasTabs" [hasToolbar]="hasToolbar">

  <!--
  UPLIFT WORK - removing app title 
  [pageTitle]="webAppTitle"
    [attr.id]="toolbarId"
  -->
  <lm-toolbar
      [inHeader]="true"
      [automationId]="screenAutomationId"
      [showGoBack]="showGoBack"
      [sectionTitle]="toolbarSectionTitle"
      [toolbarIdPrefix]="screenId"
      [asOfDate]="asOfDate"
      [buttons]="toolbarButtons | async"
      [disabled]="disabled"
      [searchField]="toolbarSearchField"
      [moreMenuSettings]="toolbarMoreSettings"

      (toolbarBackButtonEvent)="onToolbarBackButtonEvent()"
      (toolbarButtonEvent)="onToolbarButtonEvent($event)"
      (toolbarSearchEvent)="onToolbarSearchEvent($event)"
      (toolbarSearchClearedEvent)="onToolbarSearchClearedEvent($event)"
      (asOfDateChangedEvent)="onAsOfDateChangedEvent($event)"
      (asOfDateClearedEvent)="onAsOfDateCleared()"
  ></lm-toolbar>

  <div soho-tabs
      *ngIf="hasTabs"
      [containerElement]="tabsOptions?.containerElementSelector"
      [attributes]="headerTabAttributes"
      attr.data-automation-id="{{this.headerTabsetAutomationId}}"
      disableAutoUpdatedCall="true"
      (activated)="onTabActivated($event)"
  >
    <div soho-tab-list-container>
      <ul soho-tab-list>
        <li soho-tab id="{{testVersion1 ? 'pagepanel_' + tab.id : null}}" *ngFor="let tab of tabsOptions?.tabs" [selected]="tab.selected">
          <a soho-tab-title
              id="{{!testVersion1 ? tab.id + '_tab' : null}}"
              attr.data-automation-id="lm-{{tab.automationId + '-tab'}}"
              tabId="{{tab.id}}"
          >{{tab.title}}</a>
        </li>
      </ul>
    </div>
  </div>

</soho-header>
